<template>
  <div>
    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="this.getCountLive.length > 0"
    >
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-live">{{ $t('live') }} </span>
        </div>
        <div class="" @click="changeLiveMode('detail')">
          <span class="action-btn" :title="$t('allLiveEvents')"
            >{{ $t('allLiveEvents') }}
            <v-icon dense>mdi-chevron-right</v-icon></span
          >
        </div>
      </div>
      <div class="sport-live-content">
        <v-tabs
          background-color="dark accent-4"
          dark
          class="tabs-live"
          show-arrows
          align-with-title
          v-if="!this.checkIsMobile() && !this.checkIsTablet()"
        >
          <v-tab
            v-for="(item, index) in this.getCountLive"
            :key="$uuid.v1()"
            @click="changeLive(item.sport)"
          >
            <div class="single-tab">
              <!--              <span class="count">{{ item.count }}</span>-->
              <img
                :src="sportPath + item.sport.id + '.svg'"
                :alt="getTitle(item.sport)"
                class="sport-icon"
                v-bind:class="{ 'img-sport-light': light }"
              />
              <span class="text-sport">{{ getTitle(item.sport) }}</span>
            </div>
          </v-tab>
        </v-tabs>
        <v-slide-group
          show-arrows
          class="pt-2 pb-2"
          active-class="success"
          v-if="this.checkIsMobile() || this.checkIsTablet()"
        >
          <v-slide-item
            v-for="(item, index) in this.getCountLive"
            :key="$uuid.v1()"
          >
            <v-btn
              small
              class="mx-2"
              depressed
              rounded
              @click="changeLive(item.sport)"
              :class="item.selected ? 'active-sport' : ''"
            >
              <span class="text-sport text-capitalize">{{
                getTitle(item.sport)
              }}</span>
              <!--              <span class="count">{{ item.count }}</span>-->
            </v-btn>
          </v-slide-item>
        </v-slide-group>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.getLoadingLive"
        ></v-progress-linear>
        <div class="preview">
          <template v-if="!this.checkIsMobile() && !this.checkIsTablet()">
            <template v-if="!this.getLoadingLive">
              <v-slide-group multiple show-arrows class="live-slide">
                <v-slide-item
                  v-for="(object, index) in this.getPreviewLive"
                  :key="$uuid.v1()"
                  v-if="object.events[0].livescore.Scoreboard.Status == 2"
                >
                  <div class="card-live">
                    <div
                      class="card-header-live"
                      @click="
                        getDetailOfEventLive(
                          object.events[0].id,
                          object.events[0].type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          object.events[0].status
                        )
                      "
                      :title="$t('seeDetail')"
                    >
                      <div class="competitors">
                        <span
                          class="team"
                          :title="object.events[0].competitors.home.name"
                          >{{ object.events[0].competitors.home.name }}</span
                        >
                        <span
                          class="team"
                          :title="object.events[0].competitors.away.name"
                          >{{ object.events[0].competitors.away.name }}</span
                        >
                        <span
                          class="info-tournament"
                          :title="
                            object.category.name + ',' + object.tournament.name
                          "
                          >{{ object.category.name }},
                          {{ object.tournament.name | truncate(40) }}</span
                        >
                      </div>
                      <div
                        class="info-match"
                        @click="
                          getDetailOfEventLive(
                            object.events[0].id,
                            object.events[0].type,
                            object.sport.id,
                            object.tournament.id ? object.tournament.id : '',
                            object.events[0].status
                          )
                        "
                      >
                        <span
                          class="time"
                          v-if="
                            object.events[0].livescore.Scoreboard.Time != '-1'
                          "
                          >{{
                            getMatchCurrentTime(
                              object.events[0].livescore.Scoreboard.Time
                            )
                          }}<span class="blink_me">'</span></span
                        >
                        <span class="result"
                          >{{
                            getResult(
                              object.events[0].livescore.Scoreboard.Results,
                              'home'
                            )
                          }}<span class="blink_me">:</span
                          >{{
                            getResult(
                              object.events[0].livescore.Scoreboard.Results,
                              'away'
                            )
                          }}</span
                        >
                        <span class="current-period">{{
                          getMatchCurrentPeriod(
                            object.events[0].livescore.Scoreboard.CurrentPeriod
                          )
                        }}</span>
                      </div>
                    </div>
                    <div class="card-body-live">
                      <div class="market">
                        <span class="line-divider"></span>
                        <span
                          class="market-name"
                          :title="object.events[0].odds[0].name_market"
                          >{{ object.events[0].odds[0].name_market }}</span
                        >
                        <span class="line-divider"></span>
                      </div>
                      <div class="odds-market">
                        <div
                          class="odd"
                          v-for="odd in object.events[0].odds[0].odds"
                        >
                          <div
                            v-if="odd.outcome_odd_value > 0 && odd.active"
                            :class="[
                              'value',
                              'multi-' +
                                object.events[0].odds[0].multiplicity_min,
                              odd.type_change != undefined
                                ? 'odd_change_' + odd.type_change
                                : 'odd_change_equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                            @click="
                              putCart(
                                odd,
                                object.events[0],
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <span class="alias">{{
                              odd.outcome_alias || odd.outcome_name
                            }}</span>
                            <span
                              :class="[
                                odd.type_change != undefined
                                  ? 'odd_value_' + odd.type_change
                                  : 'odd_value_equal',
                                'value-odd',
                              ]"
                              >{{
                                odd.outcome_odd_value | odds_type_filter
                              }}</span
                            >
                            <div
                              :class="[
                                odd.type_change != undefined
                                  ? odd.type_change
                                  : 'equal',
                              ]"
                            ></div>
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="
                              'multi-' +
                              object.events[0].odds[0].multiplicity_min
                            "
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-slide-item>
              </v-slide-group>
            </template>
            <template v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="article"
              ></v-skeleton-loader>
            </template>
          </template>
          <template v-else-if="this.checkIsMobile() || this.checkIsTablet()">
            <VueSlickCarousel
              v-bind="settings"
              v-if="this.getPreviewLive.length"
            >
              <div
                class="card-live"
                v-for="(object, index) in this.getPreviewLive"
                :key="$uuid.v1()"
                v-if="object.events[0].livescore.Scoreboard.Status == 2"
              >
                <div
                  class="card-header-live"
                  @click="
                    getDetailOfEventLive(
                      object.events[0].id,
                      object.events[0].type,
                      object.sport.id,
                      object.tournament.id ? object.tournament.id : '',
                      object.events[0].status
                    )
                  "
                  :title="$t('seeDetail')"
                >
                  <div class="competitors">
                    <span
                      class="team"
                      :title="object.events[0].competitors.home.name"
                      >{{ object.events[0].competitors.home.name }}</span
                    >
                    <span
                      class="team"
                      :title="object.events[0].competitors.away.name"
                      >{{ object.events[0].competitors.away.name }}</span
                    >
                    <span
                      class="info-tournament"
                      :title="
                        object.category.name + ',' + object.tournament.name
                      "
                      >{{ object.category.name }},
                      {{ object.tournament.name | truncate(40) }}</span
                    >
                  </div>
                  <div
                    class="info-match"
                    @click="
                      getDetailOfEventLive(
                        object.events[0].id,
                        object.events[0].type,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : '',
                        object.events[0].status
                      )
                    "
                  >
                    <span
                      class="time"
                      v-if="object.events[0].livescore.Scoreboard.Time != '-1'"
                      >{{
                        getMatchCurrentTime(
                          object.events[0].livescore.Scoreboard.Time
                        )
                      }}<span class="blink_me">'</span></span
                    >
                    <span class="result"
                      >{{
                        getResult(
                          object.events[0].livescore.Scoreboard.Results,
                          'home'
                        )
                      }}<span class="blink_me">:</span
                      >{{
                        getResult(
                          object.events[0].livescore.Scoreboard.Results,
                          'away'
                        )
                      }}</span
                    >
                    <span class="current-period">{{
                      getMatchCurrentPeriod(
                        object.events[0].livescore.Scoreboard.CurrentPeriod
                      )
                    }}</span>
                  </div>
                </div>
                <div class="card-body-live">
                  <div class="market">
                    <span class="line-divider"></span>
                    <span
                      class="market-name"
                      :title="object.events[0].odds[0].name_market"
                      >{{ object.events[0].odds[0].name_market }}</span
                    >
                    <span class="line-divider"></span>
                  </div>
                  <div class="odds-market">
                    <div
                      class="odd"
                      v-for="odd in object.events[0].odds[0].odds"
                    >
                      <div
                        v-if="odd.outcome_odd_value > 0 && odd.active"
                        :class="[
                          'value',
                          'multi-' + object.events[0].odds[0].multiplicity_min,
                          odd.type_change != undefined
                            ? 'odd_change_' + odd.type_change
                            : 'odd_change_equal',
                          getOddsSources.includes(odd.unique_id)
                            ? 'odd_selected'
                            : '',
                        ]"
                        @click="
                          putCart(
                            odd,
                            object.events[0],
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                      >
                        <span class="alias">{{
                          odd.outcome_alias || odd.outcome_name
                        }}</span>
                        <span
                          :class="[
                            odd.type_change != undefined
                              ? 'odd_value_' + odd.type_change
                              : 'odd_value_equal',
                            'value-odd',
                          ]"
                          >{{ odd.outcome_odd_value | odds_type_filter }}</span
                        >
                        <div
                          :class="[
                            odd.type_change != undefined
                              ? odd.type_change
                              : 'equal',
                          ]"
                        ></div>
                      </div>
                      <div
                        v-else
                        class="value"
                        :class="
                          'multi-' + object.events[0].odds[0].multiplicity_min
                        "
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </template>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'
import { isMobileOnly } from 'mobile-device-detect'
import { isTablet } from 'mobile-device-detect'
import VueSlickCarousel from 'vue-slick-carousel/dist/vue-slick-carousel.umd.min'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'
export default {
  name: 'LiveWidget',
  components: { VueSlickCarousel },
  data: () => ({
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 0,
    },
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    limit: 30,
    livesCount: [],
    loading: false,
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT + '/category-images/rectangular/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/'+window.icons+'/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    sport_active: null,
    settings: {
      dots: false,
      arrows: true,
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnDotsHover: true,
      pauseOnFocus: true,
      pauseOnHover: true,
      speed: 1000,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
            arrows: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
            dots: false,
            arrows: false,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            swipeToSlide: true,
          },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getPreviewLive: 'odds/getPreviewLive',
      getCountLive: 'odds/getCountLive',
      getEventsDetailActive: 'odds/getEventsDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingLive: 'odds/getLoadingLive',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      addOddToCart: 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      setLiveMode: 'odds/setLiveMode',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    async changeLive(sport) {
      await this.setLoadingLive({ status: true })
      await this.fetchLive({
        sport: sport.id,
        sport_id: sport._id,
        group: false,
      })
      await this.setLoadingLive({ status: false })
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    groupByDate(events) {
      const refactored = _.groupBy(events, 'day')
      return refactored
    },
    increaseLimit() {
      this.limit = this.limit + this.offset
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async putCart(odd, event, sport, category, tournament) {
      if (parseFloat(odd.outcome_odd_value) > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status) {
      await this.setLoadingPreview({ status: true })
      await this.fetchEventLiveDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      await this.setLoadingPreview({ status: false })
      await this.setLiveMode({ mode: 'detail' })
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        const seconds = time - minutes * 60
        if (seconds > 0) {
          if (seconds < 10) {
            return minutes + ':0' + seconds
          } else {
            return minutes + ':' + seconds
          }
        } else {
          return minutes
        }
      } else {
        return -1
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
  },

  async mounted() {
    await this.setLoadingLive({ status: true })
    await this.fetchLive({ group: false })
    await this.setLoadingLive({ status: false })
  },
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}
</style>
